var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiListItemIcon from '@material-ui/core/ListItemIcon';
/**
 * Kareo wrapped component of the Material-UI ListItemIcon. The prop API has been limited to props defined in ListItemIconProps.
 *
 * Material-UI ListItemIcon: [Docs](https://v4.mui.com/components/lists/), [API](https://v4.mui.com/api/list-item-icon/)
 *
 * @storybook: [List](http://design.kareoprod.ent/design-system/?path=/story/components-data-display-list--icon-list-storybook)
 */
var ListItemIcon = React.forwardRef(function (props, ref) {
    return React.createElement(MuiListItemIcon, __assign({}, props, { ref: ref }));
});
ListItemIcon.defaultProps = {};
ListItemIcon.displayName = 'KareoListItemIcon';
export default ListItemIcon;
